import axiosConfig from "./axiosConfig";

class DroitParticipationService {
    async getAll() {
        try {
            const response = await axiosConfig.get("/droits");
            return response.data || [];
        } catch (error) {
            console.error("Error fetching droits de participation:", error);
            return [];
        }
    }

    async create(formData) {
        try {
            const response = await axiosConfig.post("/droits", formData);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la création:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async update(id, formData) {
        try {
            const response = await axiosConfig.put(`/droits/${id}`, formData);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la mise à jour:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async delete(id) {
        try {
            const response = await axiosConfig.delete(`/droits/${id}`);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la suppression:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }
}

const DroitParticipationServiceInstance = new DroitParticipationService();
export default DroitParticipationServiceInstance;